import React from 'react';

function Medici() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      fontSize: '3rem',
      fontWeight: 'bold'
    }}>
      În curând
    </div>
  );
}

export default Medici;
